"use client";
import dynamic from "next/dynamic";

const HtmlContent = dynamic(() => import("@/components/common/html-content"), {
  ssr: false,
});

type Props = {
  description: string;
};

export default function HTMLContentClient({ description }: Props) {
  return <HtmlContent content={description} />;
}
